// useDeleteConfirmation.ts
"use client";

import { useState } from "react";

export function useDeleteConfirmation<T>() {
  const [isOpen, setIsOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<T | null>(null);

  const open = (item: T) => {
    setItemToDelete(item);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setItemToDelete(null);
  };

  return { isOpen, itemToDelete, open, close };
}
